import { Service } from '@roc/feature-app-core';

const url = {
  GET_TRAILING_GRID: '/api/v1/loan/postClosing/postClosingTrailingDashboard',
  GET_COLLATERAL_GRID:
    '/api/v1/loan/postClosing/postClosingCollateralDashboard',
  GET_REASSIGN_GRID: '/api/v1/loan/postClosing/reassignGrid',
  EXPORT_DASHBOARD: '/api/v1/loan/postClosing/exportDashboardData',
  GET_ALL_POST_CLOSING_SPECIALISTS:
    '/api/v1/loan/postClosing/getAllPostClosingSpecialists',
  UPDATE_SPECIALIST_TO_LOANS:
    '/api/v1/loan/postClosing/updatePostClosingSpecialistForLoans',
  CAN_REASSIGN_USERS:
    '/api/v1/loan/postClosing/haveAccessToReassignPostClosingSpecialists',
  UPDATE_COLLATERAL_FIELDS:
    '/api/v1/loan/postClosing/updatePostClosingCollateralManagementFields',
};

export class PostClosingService extends Service {
  getPostClosingTrailingGrid(urlParams: string, loanProcess: string) {
    return this.get(
      `${url.GET_TRAILING_GRID}?${urlParams}&loanProcess=${loanProcess}`
    );
  }

  getPostClosingCollateralGrid(urlParams: string, loanProcess: string) {
    return this.get(
      `${url.GET_COLLATERAL_GRID}?${urlParams}&loanProcess=${loanProcess}`
    );
  }

  getPostClosingSpecialistReassignGrid(urlParams: string, loanProcess: string) {
    return this.get(
      `${url.GET_REASSIGN_GRID}?${urlParams}&loanProcess=${loanProcess}`
    );
  }

  exportDashboard(loanProcess: string, urlParams: string) {
    const urlFull = `${url.EXPORT_DASHBOARD}?loanProcess=${loanProcess}&filters=${urlParams}`;
    return this.get(urlFull, {}, { responseType: 'arraybuffer' });
  }

  getAllPostClosingSpecialists() {
    return this.get(url.GET_ALL_POST_CLOSING_SPECIALISTS);
  }

  updatePostClosingSpecialistToLoans(
    loanIds: number[],
    specialistEmail: string
  ) {
    const query = new URLSearchParams({
      loanIds: loanIds.join(','),
      userEmail: specialistEmail,
    }).toString();

    return this.post(`${url.UPDATE_SPECIALIST_TO_LOANS}?${query}`, null);
  }

  canReassignUsersToLoans(userName: string) {
    return this.get(`${url.CAN_REASSIGN_USERS}?username=${userName}`);
  }

  updateCollateralFields(updatesArray: any[]) {
    return this.post(url.UPDATE_COLLATERAL_FIELDS, updatesArray);
  }
}
